import { Divider as AntDivider } from 'antd';
import styled from 'styled-components';

import { ColorEnum } from '@enum/style/color.enum';

export const Divider = styled(AntDivider)`
  border-color: ${ColorEnum.DavyGrey};
  margin: 12px 0;
`;

export const ButtonWrapper = styled.div`
  padding-top: 12px;
`;

export const DocsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
